import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { EditPortfolioConfirmationDetails } from 'AgentApp/ts/interfaces/agent-event';

@Component({
    selector: 'ycn-edit-portfolio-confirmation-details',
    imports: [],
    templateUrl: './edit-portfolio-confirmation-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditPortfolioConfirmationDetailsComponent {
    protected readonly details = input.required<EditPortfolioConfirmationDetails>();

    protected humanizeAttribute(key: string): string {
        const spaced = key.replace(/_/g, ' ');
        return spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
}
